import { EmailMessage } from "protogen/conversation_pb";
import { FeedFocusState } from "../../types/feed";
import FeedEntryBox from "../common/FeedEntryBox";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as MailIcon } from "../../icons/MailIcon.svg";
import LinkRouter from "../navigation/LinkRouter";
import { Badge, Box } from "@mui/material";
import { StaticByline } from "./ScheduledMessageByline";
import EmailInboxLabel from "../email/EmailInboxLabel";

type EmailPreviewProps = {
  email: EmailMessage;
  isAdvisor: boolean;
  feedFocusState: FeedFocusState;
  setFeedFocusState: (s: FeedFocusState) => void;
};
export default ({ email }: EmailPreviewProps) => {
  return (
    <LinkRouter to={`/inbox/email/${encodeURIComponent(email.ref)}`}>
      <Box display="flex" flexDirection="column">
        <FeedEntryBox
          header={
            <>
              {email.isDraft && (
                <span
                  style={{
                    color: "#C14743",
                    marginRight: "4px",
                  }}
                >
                  [draft]
                </span>
              )}
              {email.subject}
            </>
          }
          subheader={
            <>
              <EmailInboxLabel emailType={email.emailType} />
              {email.teaserText}
            </>
          }
          draftTreatment={email.isDraft}
          unreadTreatment={email.unread}
          icon={
            <Badge
              color="secondary"
              variant="dot"
              overlap="circular"
              invisible={!email.unread}
              sx={{
                alignSelf: "center",
                ".MuiBadge-dot": {
                  top: "15%",
                  right: "5%",
                },
              }}
            >
              <SvgIcon
                sx={(style) => ({
                  fontSize: 24,
                  color: style.palette.text.secondary,
                })}
              >
                <MailIcon />
              </SvgIcon>
            </Badge>
          }
        />
        {email.isScheduled && (
          <StaticByline scheduledTime={email.scheduledDateSecUTC} />
        )}
      </Box>
    </LinkRouter>
  );
};
